<script setup lang="ts">
    import { PageTypes } from '#shared/resolve-page';
    defineProps<{
        data: any;
    }>();
</script>

<template>
    <section
        v-if="data.type == PageTypes.ManufacturerCategory && data?.seo?.content"
        v-html="data.seo.content"
        class="boxed-text temp-content py-10 lg:py-20" />
</template>
